<template>
  <div class="pricelist">
    <van-image width="100%" height="15rem"
      :src="priceListMainImage.imageurl"/>
    <van-grid :column-num="3">
      <van-grid-item  :text="item.classname" :icon="item.classimageurl"  v-for="item in priceListClass" @click="itemClick(item)" :key="item.classid"/>
    </van-grid>
    <el-dialog title="门店选择" :visible.sync="dialogVisible" width="70%" top="10px">
      <el-select v-model="storeid" placeholder="请选择" style="width: 100%">
        <el-option v-for="item in store" :key="item.storeid" :label="item.storename"
                   :value="item.storeid">
        </el-option>
      </el-select>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary"  size="mini" @click="saveStoreChange()">确定</el-button>
        <el-button @click="dialogVisible = false" size="mini">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      bannarimage:"",
      dialogVisible:false,
      active:"home",
      priceListClass:[],
      storeid:"",
      store:[],
      priceListMainImage:{},
    }
  },
  created() {
    this.storeid=localStorage.getItem("storeid");
    if(!this.storeid){
      this.getStoreByPrice();
      this.dialogVisible=true;
    }
    else{
      this.getPriceListClassByStore();
      this.getPriceListMainImageByStore();
    }
  },
  methods:{
    itemClick(item){
      this.$router.push({
        path:"/pricelistdetal",
        query:{classid:item.classid}
      })
    },
    getPriceListMainImageByStore(){
      this.$post("pricelist/getPriceListMainImageByStore",{storeid:this.storeid}).then(res=>{
        if(res.sucess){
          this.priceListMainImage=res.object;
          this.priceListMainImage.imageurl=this.baseImageUrl+this.priceListMainImage.imageurl;
        }
        else{
          this.$message.error(res.message);
        }
      });
    },
    saveStoreChange(){
      localStorage.setItem("storeid",this.storeid);
      this.dialogVisible=false;
      this.getPriceListClassByStore();
      this.getPriceListMainImageByStore();
    },
    getStoreByPrice(){
      this.$post("pricelist/getStoreByPrice").then(res=>{
        if(res.sucess){
          this.store=res.object;
        }
        else{
          this.$message.error(res.message);
        }
      });
    },
    getPriceListClassByStore(){
      this.$post("pricelist/getPriceListClassByStore",{storeid:this.storeid}).then(res=>{
        if(res.sucess){
          this.priceListClass=res.object;
          this.active=this.priceListClass[0].classname;
          for(let val of this.priceListClass){
            val.classimageurl=this.baseImageUrl+val.classimageurl;
          }
        }
        else{
          this.$message.error(res.message);
        }
      });
    }
  }
}
</script>
<style style lang="scss" rel="stylesheet/scss">

.pricelist{
  overflow: auto;
  height: 100%;
}

.pricelist .van-icon__image{
  width:5em;
  height:5em;
}

.pricelist .van-grid-item__text{
  font-size:15px;
}
</style>



// WEBPACK FOOTER //
// src/page/pricelist/pricelist.vue